"use client";

import { useEffect, useRef } from "react";

/**
 * Animated sprite-sheet renderer. Each sheet is a single horizontal strip of
 * `frames` cells (fw × fh each); we step the background-position-x on a timer
 * to play the loop. Ported verbatim from the Vite landing.
 */
export function Sprite({
  name,
  frames = 20,
  fw = 256,
  fh = 144,
  scale = 0.5,
  fps = 8,
  startFrame = 0,
  className = "",
}: {
  name: string;
  frames?: number;
  fw?: number;
  fh?: number;
  scale?: number;
  fps?: number;
  startFrame?: number;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const w = fw * scale;
  const h = fh * scale;
  const sheetW = fw * frames * scale;
  const step = fw * scale;

  useEffect(() => {
    let f = startFrame % frames;
    const timer = setInterval(() => {
      f = (f + 1) % frames;
      if (ref.current) ref.current.style.backgroundPositionX = `${-(f * step)}px`;
    }, 1000 / fps);
    return () => clearInterval(timer);
  }, [frames, step, fps, startFrame]);

  return (
    <div
      ref={ref}
      className={`sprite ${className}`}
      style={{
        width: w,
        height: h,
        backgroundImage: `url(/sprites/${name}.png)`,
        backgroundSize: `${sheetW}px ${h}px`,
        backgroundPositionX: `${-(startFrame % frames) * step}px`,
        backgroundPositionY: 0,
      }}
    />
  );
}
